import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Button, Space } from 'udesk-ui';
import CheckPointConditionListGatherComponent from './component';
import CheckPointCondition from 'Component/pages/components/check-point-condition-list-gather/check-point-condition';
import { AssociateProvider, WorkTimeProvider } from './Contxt';
import { hasFeature } from 'src/util/permit';
import './style.scss';

export default class CheckPointConditionListGatherTemplate extends CheckPointConditionListGatherComponent {
    render() {
        let { props, actions, privates } = this;

        let {
            isNewAssociate = 1,
            isAutoAssociateDateSource = 1,
            replenishConditionTypes,
            replenishOperatorTypes,
            showApplyTimeType = false,
            disabled = false,
            showSmartModelType = false,
            isLargeModelRule = false,
            showMultiModal = false,
        } = props;

        let { conditionList, conditionTypeList, fieldDataList } = privates;

        let showConditionTypeList = props.isCollection
            ? conditionTypeList.filter((item) => item.key === 1)
            : props.type.includes(0) && props.ruglar !== 'preprocess'
            ? conditionTypeList.filter((item) => item.key !== 4)
            : props.type.includes(Udesk.enums.inspectDataSources.survey.id)
            ? conditionTypeList.filter((item) => item.key !== 2)
            : conditionTypeList.slice();

        //类型补充函数，可以对显示类型进行修正
        if (replenishConditionTypes) {
            replenishConditionTypes(showConditionTypeList, conditionTypeList);
        }

        if (showSmartModelType) {
            showConditionTypeList.push({
                key: 5,
                name: /* 模型 */ UdeskLocales['current'].components.checkPointConditionListGather
                    .template.model,
            });
        }

        showConditionTypeList = showConditionTypeList.map((item) => {
            if (item.key === 1) {
                return {
                    ...item,
                    name: this.props.isLargeModelRule
                        ? /* 大模型 */ UdeskLocales['current'].components
                              .checkPointConditionListGather.component.largeModel
                        : UdeskLocales.current.pages.tasks.manage.template.checkPoint.configuration
                              .ruleType.words,
                };
            } else {
                return item;
            }
        });

        if (
            showMultiModal &&
            hasFeature('sys:largeAi:qa:multimodal') &&
            props.type.find((t) =>
                [
                    Udesk.enums.inspectDataSources.realTimeVoiceCall.id,
                    Udesk.enums.inspectDataSources.voiceCall.id,
                    Udesk.enums.inspectDataSources.textDialogue.id,
                    Udesk.enums.inspectDataSources.realTimeTextDialogue.id,
                    Udesk.enums.inspectDataSources.wechatDialogue.id,
                    // Udesk.enums.inspectDataSources.feishuGroup.id,
                    Udesk.enums.inspectDataSources.videoCall.id,
                ].includes(t)
            )
        ) {
            showConditionTypeList.push({
                key: 6,
                name: /* 多模态 */ UdeskLocales['current'].components.checkPointConditionListGather
                    .template.multimodal,
            });
        }

        return (
            <div className="check-point-condition-list-gather">
                <WorkTimeProvider>
                    <AssociateProvider type={props.type} lang={props.lang}>
                        {conditionList &&
                            conditionList.length !== 0 &&
                            conditionList.map((condition, index) => {
                                return (
                                    <div
                                        className="check-point-condition-list-item"
                                        key={condition.idCode}
                                    >
                                        <CheckPointCondition
                                            // {...this.props}
                                            isNewAssociate={isNewAssociate}
                                            isAutoAssociateDateSource={isAutoAssociateDateSource}
                                            funcType={props.funcType}
                                            key={condition.idCode}
                                            conditionList={conditionList}
                                            condition={condition}
                                            conditionTypeList={showConditionTypeList}
                                            type={props.type}
                                            ruglar={props.ruglar}
                                            fieldDataList={fieldDataList}
                                            onChange={actions.handleConditionListChange.params(
                                                index
                                            )}
                                            isWechatQa={props.isWechatQa}
                                            isSales={props.isSales}
                                            replenishOperatorTypes={replenishOperatorTypes}
                                            showApplyTimeType={showApplyTimeType}
                                            taskId={props.taskId}
                                            hasSummaryRule={props.hasSummaryRule}
                                            lang={props.lang}
                                            disabled={disabled}
                                            isLargeModelRule={isLargeModelRule}
                                            isPreprocess={props.ruglar === 'preprocess'}
                                        ></CheckPointCondition>

                                        <div
                                            className="tasks-manage-template-configuration-detail-rule-item-delete"
                                            onClick={
                                                !disabled
                                                    ? actions.deleteCondition.params(index)
                                                    : () => {}
                                            }
                                        >
                                            <span
                                                className="udesk-qa-react-web-iconfont"
                                                style={{
                                                    fontSize: '24px',
                                                    cursor: 'pointer',
                                                    color: 'rgba(0,0,0,0.15)',
                                                }}
                                            >
                                                &#xe653;
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                    </AssociateProvider>
                </WorkTimeProvider>

                <div
                    className="check-point-condition-list-add"
                    key={'check-point-condition-list-add'}
                >
                    <Space>
                        {showConditionTypeList.map((item) => {
                            return (
                                <Button
                                    key={item.key}
                                    onClick={actions.addCondition.params(item.key)}
                                    // type='text'
                                    // className='check-point-condition-list-add-btn'
                                    disabled={disabled}
                                >
                                    <span
                                        className="udesk-qa-react-web-iconfont"
                                        style={{
                                            fontSize: '16px',
                                            marginRight: '8px',
                                            cursor: 'pointer',
                                            lineHeight: '16px',
                                        }}
                                    >
                                        &#xe610;
                                    </span>
                                    {item.name}
                                </Button>
                            );
                        })}
                    </Space>
                </div>
            </div>
        );
    }
}
